import { ComponentProps } from 'react';
import { Box, Spinner, VStack } from 'native-base';
import { isEmpty } from 'lodash';

import { Text } from '@pimm/base';
import { StringTranslation } from '@pimm/services/lib/sms-tenants';
import { useAppLocale } from '@pimm/common';

export type WidgetBoxProps = ComponentProps<typeof VStack> & {
  isLoading?: boolean;
  noPadding?: boolean;
  title?: string;
  titleTranslations?: StringTranslation[];
  hideTitle?: boolean;
};

export const WidgetBox = ({ children, isLoading, noPadding = false, title, titleTranslations, hideTitle = false, ...props }: WidgetBoxProps) => {
  const { translate } = useAppLocale();
  return (
    <VStack shadow={1} rounded="lg" p={noPadding ? 0 : { md: 1.5, xl: 2 }} minHeight={120} bgColor="white" {...props}>
      {isLoading === true && <Spinner position="absolute" top={1.5} right={2} size={14} color="gray.500" />}
      {!isEmpty(title) && !hideTitle && (
        <Text
          size="sm"
          mb={2}
          fontWeight={700}
          color="gray.600"
          lineHeight="md"
          textTransform="uppercase"
          numberOfLines={1}
          ellipsizeMode="tail"
        >
          {translate(title, titleTranslations)}
        </Text>
      )}
      <Box flex={1}>{children}</Box>
    </VStack>
  );
};
